import { Subject } from 'rxjs';

export const notificationSubject = new Subject();
export const talkingPageySubject = new Subject();
export const apiErrorSubject = new Subject();